import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {SearchRepositoriesFactory} from '../Repositories/factory.js'

class GetLastSearchUrlUseCase extends UseCase {
  #config
  #localStorageRepository

  static create({config}) {
    return new GetLastSearchUrlUseCase({
      config,
      localStorageRepository: SearchRepositoriesFactory.localStorageSearchRepository({config})
    })
  }

  constructor({config, localStorageRepository}) {
    super()

    this.#config = config
    this.#localStorageRepository = localStorageRepository
  }

  @tracer({metric: 'GetLastSearchUrlUseCase#execute'})
  @inlineError
  async execute() {
    const NAVIGATION_TYPES = this.#config.get('NAVIGATION_TYPES')
    const [error, response] = await this.#localStorageRepository.getLastSearchUrl({type: NAVIGATION_TYPES.ADS})

    if (error) return Promise.reject(error)

    return response
  }
}

export default GetLastSearchUrlUseCase.create
